import {fromJS, Map} from 'immutable';

import treeReducer from '../components/tree/reducer';

export const ADD_REDUCER = 'DYNAMIC_REDUCER_ADD';
export const REMOVE_REDUCER = 'DYNAMIC_REDUCER_REMOVE';
export const CLEAR_REDUCERS = 'DYNAMIC_REDUCER_CLEAR';

export function addReducer(name, reducer, initialState, elementId) {
    if (elementId === undefined) {
        elementId = initialState;
        initialState = undefined;
    }
    else {
        initialState = fromJS(initialState);
    }
    return {
        type: ADD_REDUCER,
        elementId,
        payload: {name, reducer, initialState},
    };
}

export function removeReducer(name, elementId) {
    return {
        type: REMOVE_REDUCER,
        elementId,
        payload: {name},
    };
}

export function clearReducers(elementId) {
    return {
        type: CLEAR_REDUCERS,
        elementId,
    };
}

const reducers = {
    tree: treeReducer,
};

export default function dynamicReducer(
    state = fromJS({elementId: window.uuidv4(), reducers: new Map(), states: new Map()}),
    action,
) {
    if (action.elementId === state.get('elementId')) {
        switch (action.type) {
        case ADD_REDUCER:
            state = state.setIn(['reducers', action.payload.name], action.payload.reducer).setIn(
                    ['states', action.payload.name],
                    reducers[action.payload.reducer](action.payload.initialState, {type: '__JUST_INITIALIZE'}),
                );
            break;

        case REMOVE_REDUCER:
            state = state.removeIn(['reducers', action.payload.name]).removeIn(['states', action.payload.name]);
            break;

        case CLEAR_REDUCERS:
            state = state.set('reducers', new Map()).set('states', new Map());
            break;
        }
    }
    state.get('reducers').forEach((reducer, name) => {
        const newState = reducers[reducer](state.getIn(['states', name]), action);
        state = state.setIn(['states', name], newState);
    });
    return state;
}
